<template>
  <div class="container">
    <div class="row">
      
      <div class="col-12 col-sm-6 col-md-4">
        <div class="btn-group">
          <button type="button" class="btn btn-secondary dropdown-toggle dropdown-btn" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            {{selectedButton}}
          </button>
          <div class="dropdown-menu">
            <button v-on:click="selectedItem(false)" class="dropdown-item">All Downloads</button>
            <div class="dropdown-divider"></div>
            <button v-on:click="selectedItem(option)" v-for="option in osarchoptions" :key="option" class="dropdown-item">{{option}}</button>
          </div>
        </div>
      </div>
      <div class="col-12 col-sm-6 col-md-8">
        <p class="download-text">
          Not seeing what you're looking for?
          <a
            :href="CONSTANTS.DOWNLOADS_MAIL_TO"
          >Click here to let us know.</a>
        </p>
      </div>
    </div>
    <div class="row table-container">
      <div class="col-12 pb-4 pt-4">
        <app-table
          :apps="downloadApps"
          :columns="columns"
          :pagination-options="paginationOptions"
          :sort-options="sortOptions"
          :onSortChangeFunc="onSortChange"
        ></app-table>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
import util from "@/util";
import AppTable from "@/components/AppTable";
import * as CONSTANTS from "../constants.js";
import AppHandlerMixin from "@/mixins/AppHandlerMixin";

export default {
  name: "Downloads",
  components: {
    AppTable
  },
  mixins: [AppHandlerMixin],
  props: {
    apps: Array
  },
  data: function() {
    return {
      selectedButton : "All Downloads",     
      CONSTANTS,
      columns: [
        {
          label: "Title",
          field: "title"
        },
        {
          label: "Description",
          field: "tag_line"
        },
        {
          label: "Access",
          field: "access.last_accessed",
          sortFn: util.accessStateSort
        },
        {
          label: "Entitlement",
          field: "access.state",
          sortFn: util.entitlementSort
        },
        {
          label: "Link",
          field: "root_link",
          sortable: false
        }
      ],
      paginationOptions: {
        enabled: false,
        mode: "records",
        perPage: 50,
        position: "bottom",
        perPageDropdown: [50, 100],
        dropdownAllowAll: true,
        setCurrentPage: 1,
        nextLabel: "next",
        prevLabel: "prev",
        rowsPerPageLabel: "Rows per page",
        ofLabel: "of",
        pageLabel: "page",
        allLabel: "All"
      },
      sortOptions: {
        enabled: true,
        initialSortBy: { field: "title", type: "asc" }
      },
      downloadApps: [],
      downloadModel: null
    };
  },
  computed: {
    ...mapGetters([
      "getViewType",
      "getApplications",
      "getApplicationById",
      "getPreviousDownloadTableSortOpts"
    ])
  },
  mounted() {
    this.downloadApps = this.getApplications.filter(e => e.type === "download");
  },
  created() {
    this.sortOptions = this.getPreviousDownloadTableSortOpts;
    this.setDropDownOptions();
  },
  methods: {
    ...mapMutations(["setPreviousDownloadTableSortOpts"]),
    setModel(model) {
      this.downloadModel = this.getApplicationById(model.id);
      this.downloadModel.show = true;
    },
    onSortChange(params) {
      let tmp = {
        enabled: true,
        initialSortBy: {
          field: this.columns[params.columnIndex].field,
          type: params.sortType
        }
      };
      this.setPreviousDownloadTableSortOpts(tmp);
    },
    setDropDownOptions(){
    let drpItems = [];
    let drpItem = "";
    let downloadedApps = this.getApplications.filter(e => e.type === "download");
    let itemExists = false;

    for(let app of downloadedApps){
        let os = app.root_link.reference.os;
        if(os && typeof os != "undefined"){
            for(let osItem of os){
              if(osItem.architecture){
                   for(let archItem of osItem.architecture){
                      drpItem = osItem.label + "(" + archItem.label + ")";
                      itemExists = drpItems.filter(item => item.toLowerCase().trim() == drpItem.toLowerCase().trim());
                      if(itemExists.length == 0){
                        drpItems.push(drpItem);
                      }
                   }
              }
            }
        }
    }
    this.osarchoptions = drpItems;
   },
   selectedItem(option) {
      this.downloadApps = this.getApplications.filter(e => e.type === "download");
      let context = this;
      if (option) {
         this.selectedButton = option;  
         this.downloadApps = this.downloadApps.filter((app) => {
            let appArchItem = "";
            let appArchItems = [];
            let os = app.root_link.reference.os;
            if(os && typeof os != "undefined"){
                for(let osItem of os){
                  if(osItem.architecture){
                      for(let archItem of osItem.architecture){
                          appArchItem = osItem.label + "(" + archItem.label + ")";
                          appArchItems.push(appArchItem);
                      }
                  }
                }
            }
           return (appArchItems.includes(option));
         });
       }
      else{
         this.selectedButton = "All Downloads";  
      } 
    }
  }
};
</script>
<style scoped>
.download-text {
  float: right;
  font-size: 14px;
  margin-bottom: 0;
  padding-top: 15px;
}
.table-container {
  margin-bottom: 25px;
}

.dropdown-btn:hover,.dropdown-item:hover {
  background-color: var(--secondary-color) !important;
  color: #ffffff !important;
}
.dropdown-btn,.dropdown-item {
  background-color: #ffffff !important;
  color: var(--secondary-color)  !important;
  border-color: var(--secondary-color) !important;
  border-radius: 0;
  cursor: pointer;
  font-size : 14px
}

.dropdown-menu {
  border-radius: 0;
}

.dropdown-menu:hover {
    background-color: #fff;
}


@media (max-width: 991px) {
  button {
    margin-left: 0px;
  }
}
</style>
